module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1bd7e4561286956370f8bcc27c43aa82.png";